/* eslint-disable no-unused-vars */
import { Box, Text } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import DuplicateListTable from "../../../Components/AdminComponents/Duplication/DuplicateListTable";
import LoadingSpinner from "../../../LoadingSpinner";

const Duplication = () => {
  const [records, setRecords] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    fetch(`/api/getDedupList`)
      .then((response) => response.json())
      .then((data) => {
        setRecords(data);
        setIsLoading(false);
      })
      .catch((error) => setIsLoading(false));
  }, []);

  return (
    <Box m={1}>
      {isLoading && <LoadingSpinner />}
      {!isLoading && records?.length > 0 && (
        <>
          <DuplicateListTable data={records} />
        </>
      )}
      {!isLoading && records?.length < 0 && (
        <Text textAlign="center" fontSize="lg">
          No data found!
        </Text>
      )}
    </Box>
  );
};

export default Duplication;
